export default "__VITE_ASSET__BTDu6kVC__"